export default __webpack_public_path__ + "static/media/invoice_box.911f317b.svg";